module.exports = __webpack_public_path__ + "img/third_way_bg.2115e4d1.png";